<template>
  <div class="distributor-box details_box_styles">
    <div class="flex align-items-center justify-content-between mt12 mb12">
      <!--返回按钮-->
      <div class="go-back" style="margin: 0;" @click="goBackBtn">
        <Icon class="back-icon" type="ios-arrow-back"/>
        <span class="back-txt">{{ $t('key1002627') }}</span>
      </div>
      <div class="flex align-items-center">
        <Button type="primary" class="mr20"
          v-if="(detailsData.isHand === 2 && ![6, 7, 8].includes(detailsData.status)) || detailsData.allowInvalid === 1"
          @click="changeOrderItemBtn">{{ $t('key1006100') }}</Button>
        <Button type="primary" v-if="cancelOrderTalg" @click="cancellationOfOrderBtn">{{ $t('key1004290') }}</Button>
      </div>
    </div>
    <!--步骤条-->
    <div class="basic_information_box" v-if="showSteps">
      <Card :bordered="false" dis-hover>
        <h2 class="title_center">{{ detailsData.status === 8 ? detailsData.packageCode + $t('key1005936') : $t('key1006135') }}</h2>
        <div class="steps_box" style="width: 70%" v-if="detailsData.status !== 8">
          <Steps :current="currentStatus">
            <Step
              v-for="(ele, ids) in stepsList"
              :key="ids"
              :title="ele.title"
              :icon="ele.icon">
              <div slot="content" class="flex flex-direction ml32">
                <span v-if="ele.text" class="distributorThemeColor">{{ ele.text }}</span>
                <span>{{ ele.time }}</span>
              </div>
            </Step>
          </Steps>
        </div>
      </Card>
    </div>
    <!--主信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <Tabs v-model="informationTab">
          <TabPane :label="$t('key1004417')" name="mainInformation">
            <Row type="flex" :gutter="gutterItem">
              <Col :span="ItemCol" class="basic_item" v-for="ele in mainInfoList">
                <span class="basic_title">{{ ele.title + '：' }}</span>
                <span class="basic_txt">{{ detailsData[ele.paramsKey] }}</span>
              </Col>
              <Col :span="ItemCol" class="basic_item" v-if="detailsData.chargeableWeight !==''">
                <span class="basic_title">{{ $t('key1006136') + detailsData.weightUnit + ')：' }}</span>
                <span class="basic_txt">{{ detailsData.chargeableWeight }}</span>
              </Col>
            </Row>
          </TabPane>
          <TabPane :label="labelFun" name="consigneeInformation">
            <Row type="flex" :gutter="gutterItem">
              <Col :span="ItemCol" class="basic_item" v-for="ele in consigneeInfoList">
                <span class="basic_title">{{ ele.title + '：' }}</span>
                <span class="basic_txt">{{ detailsData[ele.paramsKey] }}</span>
              </Col>
            </Row>
          </TabPane>
          <TabPane :label="$t('key1004419')" name="logisticsInformation">
            <Row type="flex" :gutter="gutterItem">
              <Col :span="ItemCol" class="basic_item" v-for="ele in logisticsInfoList">
                <span class="basic_title">{{ ele.title + '：' }}</span>
                <span class="basic_txt" :title="detailsData[ele.paramsKey]">{{ detailsData[ele.paramsKey] }}</span>
              </Col>
            </Row>
          </TabPane>
        </Tabs>
      </Card>
    </div>
    <!--列表-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <div class="table_box">
          <Table
            highlight-row
            border
            max-height="450"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="tableData">
          </Table>
        </div>
      </Card>
    </div>
    <!--修改收货人信息弹窗-->
    <editReceiverModal ref="editReceiver" receiverType="myOrder" @updateData="getDetailsData()"></editReceiverModal>
    <!--取消订单弹窗-->
    <cancelYmsOrderModal ref="cancelYmsOrder" @cancelYmsOrderSuccess="updateYmsOrderSuccess"></cancelYmsOrderModal>
    <!--更换订单商品弹窗-->
    <replaceYmsOrderGoodsModal ref="replaceYmsOrderGoods" @replaceYmsOrderGoodsSuccess="updateYmsOrderSuccess"></replaceYmsOrderGoodsModal>
    <!--取消定制商品订单弹窗-->
    <cancelCustomizedProductOrdersModal
      ref="cancelCustomizedProductOrders"
      @cancelYmsOrderSuccess="updateYmsOrderSuccess"
    ></cancelCustomizedProductOrdersModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import {YMSORDERSTATUSLIST} from "@/utils/enum";
import editReceiverModal from "@/views/distributor/components/orderManage/components/editReceiverModal.vue";
import cancelYmsOrderModal from "@/views/distributor/components/orderManage/components/cancelYmsOrderModal.vue";
import replaceYmsOrderGoodsModal from "@/views/distributor/components/orderManage/components/replaceYmsOrderGoodsModal.vue";
import {commonCopyContent, getQueryCarrierShippingName, getUserNameByUserId, setConfigCharacters, getAllUsersInfo, getDataSetBatchList, getEnumName} from "@/utils/common";
import cancelCustomizedProductOrdersModal from "@/components/common/cancelCustomizedProductOrdersModal.vue";

export default {
  name: "myOrderDetails",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      informationTab: 'mainInformation',
      detailsData: {},
      currentStatus: 0,
      tableColumns: [
        {
          title: 'NO',
          key: 'index',
          align: 'left',
          width: 70,
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          key: 'commodityInfo',
          align: 'left',
          minWidth: 450,
          render(h, params) {
            let name = params.row.name;
            let specifications = params.row.specifications;
            let ymsSku = params.row.ymsSku;
            let originalYmsSku = params.row.originalYmsSku;
            let isNeedCustomization = params.row.isNeedCustomization;
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, 'pictureUrl'),
              h('div', {class: 'ml5'}, [
                h('Alink', {
                  props: {
                    AlinkShow: false,
                    linkName: name,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_1'
                  }
                }),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1
                    },
                    class: 'color-green'
                  }, specifications),
                ]),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', `${setConfigCharacters(false)}SKU：` + ymsSku),
                  h('Icon', {
                    props: {
                      type: 'ios-copy-outline',
                      size: 18,
                      color: '#01a6ee'
                    },
                    style: {
                      marginLeft: '10px',
                      cursor: 'pointer'
                    },
                    attrs: {
                      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003')
                    },
                    on: {
                      click: () => {
                        commonCopyContent(ymsSku, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001286'));
                      }
                    }
                  })
                ]),
                isNeedCustomization === 1 ? h('p', {class: 'flex align-items-center'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004552') + originalYmsSku + ')'),
                  h('Tooltip', {
                    props: {
                      transfer: true,
                      maxWidth: 450,
                      content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004306'),
                      placement: 'top'
                    }
                  }, [
                    h('Icon', {
                      props: {
                        type: 'md-alert',
                        size: 17
                      },
                      class: 'cursor ml5 distributorThemeColor'
                    })
                  ])
                ]) : '',
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
          key: 'quantity',
          minWidth: 110,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000854'),
          key: 'productGoodsWeight',
          minWidth: 110,
          align: 'left',
          render(h, params) {
            let productGoodsWeight = params.row.productGoodsWeight || 0;
            let text = productGoodsWeight + 'g';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004372'),
          key: 'outOfStockStatus',
          minWidth: 110,
          align: 'left',
          render(h, params) {
            let abnormalStatus = params.row.abnormalStatus; // 1.正常 2.缺货 3部分缺货
            let goodsStatus = params.row.goodsStatus; // 1.正常 2.停售
            let estimateArrivalOfGoodsTime = params.row.estimateArrivalOfGoodsTime ?
              v.$uDate.dealTime(params.row.estimateArrivalOfGoodsTime) : null;
            let expectedDeliveryTimeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006118') + estimateArrivalOfGoodsTime + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006119');
            let list = [];
            // 停售
            if (goodsStatus === 2) {
              list.push(h('p', {class: 'mt2 mb1 crimsonRedColor'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000084')));
            }
            // 缺货-补货中
            else {
              if (abnormalStatus === 2) {
                if (goodsStatus === 1) {
                  list.push(
                    h('div', {class: 'crimsonRedColor'}, [
                      h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004364')),
                      estimateArrivalOfGoodsTime ? h('div', {class: 'flex'}, [
                        h('span', {class: 'crimsonRedColor'}, expectedDeliveryTimeText),
                        h('Tooltip', {
                          props: {
                            transfer: true,
                            maxWidth: 450,
                            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006120')
                          },
                          style: {
                            marginLeft: '5px'
                          }
                        }, [
                          h('Icon', {
                            props: {
                              type: 'md-information-circle',
                              size: 16
                            },
                            style: {
                              cursor: 'pointer',
                              color: 'red'
                            }
                          })
                        ]),
                      ]) : '',
                    ])
                  );
                }
              } else if (abnormalStatus === 1) {
                list.push(h('p', {class: 'mt2 mb1'}, '-'));
              }
            }
            return h('div', list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000524'),
          key: 'outOfStockQuantity',
          minWidth: 110,
          align: 'left',
          render(h, params) {
            let abnormalStatus = params.row.abnormalStatus;
            let outOfStockQuantity = params.row.outOfStockQuantity || '-';
            return abnormalStatus === 2 ? h('span', {class: outOfStockQuantity > 0 ? 'crimsonRedColor' : ''}, outOfStockQuantity) : h('span', '-');
          }
        },
      ],
      tableData: [],
      stepsList: [],
      showSteps: false,
      mainInfoList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006121'), paramsKey: 'packageCode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003818'), paramsKey: 'labelTypeTxt'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522'), paramsKey: 'orderShippingId'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'), paramsKey: 'createdTime'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'), paramsKey: 'creatorText'}
      ], // 主信息字段
      consigneeInfoList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006122'), paramsKey: 'buyerName'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002586'), paramsKey: 'buyerCountryCode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006123'), paramsKey: 'buyerPassportCode'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002811'), paramsKey: 'buyerName'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002333'), paramsKey: 'buyerState'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002812'), paramsKey: 'buyerMobile'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002852'), paramsKey: 'buyerPhone'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002334'), paramsKey: 'buyerCity'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'), paramsKey: 'buyerEmail'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006124'), paramsKey: 'buyerAddress1'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006125'), paramsKey: 'buyerAddress2'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002340'), paramsKey: 'buyerPostalCode'}
      ], // 收货人信息字段
      logisticsInfoList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220'), paramsKey: 'providerName'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004440'), paramsKey: 'thirdPartyNo'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006126'), paramsKey: 'providerModeName'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004458'), paramsKey: 'trackingNumber'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004459'), paramsKey: 'virtualTrackingNumber'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006127'), paramsKey: 'carrierWeight'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006128'), paramsKey: 'estimateFreight'}
      ], // 物流商信息字段
      labelFun: (h) => {
        let sourceTalg = v.detailsData.source === 'YMS';
        return h('div', {class: 'flex align-items-center'}, [
          h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004418')),
          sourceTalg && (![6, 7, 8].includes(v.detailsData.status) || v.detailsData.allowInvalid === 1) ? h('Icon', {
            props: {
              type: 'md-create',
              color: '#FD5425',
            },
            style: {
              fontSize: '18px',
              marginLeft: '5px',
              marginRight: 0,
              position: 'relative',
              top: '-4px'
            },
            on: {
              click: () => {
                let obj = {
                  ymsPackageInfo: v.detailsData,
                };
                v.$refs['editReceiver'].initEditReceiverData(obj, 'edit');
              }
            }
          }) : ''
        ]);
      },
      generalMerchandiseList: [],
      userInfoList:{},
      enumData: []
    };
  },
  computed: {
    ItemCol() {
      return this.languagesVal === 'zh-CN' ? 6 : 8;
    },
    // 判断是否可以取消订单
    cancelOrderTalg() {
      let v = this;
      let obj = v.detailsData;
      let abnormalStatus = obj.abnormalStatus;
      let handTalg = obj.isHand === 2; // 是否手工单:(0:否 1:平台手工单 2:yms手工单)
      let sourceTalg = obj.source !== 'YMS'; // 第三方渠道的订单
      let status = obj.status; // 订单状态
      let allowInvalid = obj.allowInvalid; // 1 允许标记取消   0不允许标记取消
      let isNeedCustomization = obj.isNeedCustomization;
      return (isNeedCustomization === 0 && (((handTalg || sourceTalg) && ![6, 7, 8].includes(status)) ||
          (abnormalStatus === 2 && status !== 8) || (allowInvalid === 1 && status === 6)) || isNeedCustomization === 1) &&
        v.getPermission('ymsPlatformOrder_cancelOrder');
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList = ['YmsPickupOrderLabelTypeCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      await getAllUsersInfo().then((data) => {
        this.userInfoList = data;
      });
      await this.getDetailsData();
    },
    // 返回列表
    goBackBtn() {
      this.$router.push('/myOrder');
    },
    // 获取订单详情的数据
    getDetailsData() {
      let v = this;
      v.tableLoading = true;
      v.axios.get(api.get_ymsDistributorPackageInfo + `${v.$route.query.ymsPackageId}`, {loading: true}).then(response => {
        v.tableLoading = false;
        v.$store.commit('updateDistributorMenu', false);
        if (response.data.code === 0) {
          let data = response.data.datas;
          let ymsStatus = data.ymsStatus;
          data.labelTypeTxt = getEnumName(v.enumData, 'YmsPickupOrderLabelTypeCoreEnum', data.labelType);
          // 获取物流商数据
          if (data.shippingMethodId) {
            getQueryCarrierShippingName([data.shippingMethodId]).then((shippingMethodList) => {
              if (shippingMethodList.length > 0) {
                shippingMethodList.map((item) => {
                  if (item.shippingMethodId === data.shippingMethodId) {
                    data.providerName = item.carrierName;
                    data.providerModeName = item.carrierShippingMethodName;
                  }
                });
              }
            });
          }
          /**
           * 只有不是创建状态的时候，才会展示订单流程进度条
           */
          if (data.status !== 1 && ymsStatus) {
            let needPurchaseTalg = data.needPurchase === 0; // 0 YMS订单不需要采购
            let stepsList = [];
            if (needPurchaseTalg) {
              stepsList = [
                {status: 0, icon: 'md-cash', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), time: data.createdTime},
                {status: 1, icon: 'ios-basket', title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}`, time: null},
                {status: 2, icon: 'md-car', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006129'), time: null}
              ];
            } else {
              stepsList = [
                {status: 0, icon: 'md-cash', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), time: data.createdTime},
                {status: 1, icon: 'md-cart', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006130'), time: null},
                {status: 2, icon: 'ios-basket', title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}`, time: null},
                {status: 3, icon: 'md-car', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006129'), time: null}
              ];
            }
            let arr = YMSORDERSTATUSLIST.filter((k) => {
              if (needPurchaseTalg) {
                return k.value <= ymsStatus && k.value !== 'null' && k.value >= 6;
              } else {
                return k.value <= ymsStatus && k.value !== 'null';
              }
            });
            let keyList = arr.map((j) => {
              return j.key;
            });
            keyList.map((key) => {
              if (data[key]) {
                let text = '';
                if (needPurchaseTalg) {
                  switch (key) {
                    case 'allottedTime':
                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001808');
                      stepsList[1].time = data[key];
                      stepsList[1].text = text;
                      break;
                    case 'pickedTime':
                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001809');
                      stepsList[1].time = data[key];
                      stepsList[1].text = text;
                      break;
                    case 'changedLabelTime':
                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001810');
                      stepsList[1].time = data[key];
                      stepsList[1].text = text;
                      break;
                    case 'boxedTime':
                      text = '';
                      stepsList[1].time = data[key];
                      stepsList[1].text = text;
                      break;
                    case 'shipedTime':
                      stepsList[1].title = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006117')}`;
                      stepsList[2].time = data.shipedTime;
                      stepsList[2].title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006131');
                      break;
                  }
                } else {
                  switch (key) {
                    case 'printTime':
                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001802');
                      stepsList[1].time = data[key];
                      stepsList[1].text = text;
                      break;
                    case 'pickingFinishTime':
                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001803');
                      stepsList[1].time = data[key];
                      stepsList[1].text = text;
                      break;
                    case 'packingTime':
                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001804');
                      stepsList[1].time = data[key];
                      stepsList[1].text = text;
                      break;
                    case'supperBoxedTime':
                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001805');
                      stepsList[1].time = data[key];
                      stepsList[1].text = text;
                      break;
                    case 'despatchTime':
                      text = '';
                      stepsList[1].time = data[key];
                      stepsList[1].text = text;
                      break;
                    case 'allottedTime':
                      stepsList[1].title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005932');
                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001808');
                      stepsList[2].time = data[key];
                      stepsList[2].text = text;
                      break;
                    case 'pickedTime':
                      stepsList[1].title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005932');
                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001809');
                      stepsList[2].time = data[key];
                      stepsList[2].text = text;
                      break;
                    case 'changedLabelTime':
                      stepsList[1].title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005932');
                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001810');
                      stepsList[2].time = data[key];
                      stepsList[2].text = text;
                      break;
                    case 'boxedTime':
                      stepsList[1].title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005932');
                      text = '';
                      stepsList[2].time = data[key];
                      stepsList[2].text = text;
                      break;
                    case 'shipedTime':
                      stepsList[2].title = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006117')}`;
                      stepsList[3].time = data.shipedTime;
                      stepsList[3].title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006131');
                      break;
                  }
                }
              }
            });
            if (stepsList.length > 0) {
              stepsList.map((ele) => {
                if (ele.time) {
                  v.currentStatus = ele.status;
                  ele.time = v.$uDate.dealTime(ele.time, 'fulltime');
                }
              });
            }
            v.stepsList = stepsList;
            v.showSteps = true;
          } else {
            v.showSteps = false;
          }
          if (data.createdTime) {
            data.createdTime = v.$uDate.dealTime(data.createdTime, 'fulltime');
          }
          // 计费重量
          data.weightUnit = 'g';
          data.chargeableWeight = '';
          if (data.extendJson) {
            let extendJson = JSON.parse(data.extendJson);
            if (Object.keys(extendJson).length > 0) {
              if (extendJson.totalWeight) {
                data.chargeableWeight = extendJson.totalWeight;
              }
              data.weightUnit = extendJson.weightUnit || 'g';
            }
          }
          // 创建人
          let sourceTypeList = [
            {type: 'BAILUN', name: 'Bailun'},
            {type: 'YMS', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006132')},
            {type: 'TONGTOOL3.0', name: 'TONGTOOL ERP3.0'},
            {type: 'tongtool_old', name: 'TONGTOOL ERP'},
            {type: 'LAPA', name: 'LAPA'},
            {type: 'MIAOSHOU', name: 'MiaoShou'},
          ];
          data['creatorText'] = '-';
          if (data.isHand === 2) {
            data['creatorText'] = getUserNameByUserId(data.createdBy, v.userInfoList) || '-';
          } else {
            sourceTypeList.map((item) => {
              if (item.type === data.source) {
                data['creatorText'] = item.name;
              }
            });
          }

          v.detailsData = data;
          let newData = v.handleMultilinguaTableFields(data.ymsPackageGoods, ['title']);
          let ymsProductGoodsIds = [];
          if (newData.length > 0) {
            newData.map((item) => {
              ymsProductGoodsIds.push(item.ymsProductGoodsId);
            });
            if (ymsProductGoodsIds.length > 0) {
              (async () => {
                let newList = await v.getProductInfoByIds(ymsProductGoodsIds, newData);
                if (newList.length > 0) {
                  newList.map((item) => {
                    if (item._productInfo) {
                      let skuImgPath = item._productInfo.primaryImage;
                      let spuImgPath = item._productInfo._spuInfo.primaryImage;
                      let productGoodsSpecificationList = item._productInfo.productGoodsSpecificationList || [];
                      item.specifications = productGoodsSpecificationList.map(i => i.name + '：' + i.value).join('、');
                      item.name = item._productInfo._spuInfo.name;
                      item.ymsSku = item._productInfo.ymsSku;
                      item.pictureUrl = skuImgPath ? skuImgPath : spuImgPath;
                      item.cancelQuantity = 0;
                    }
                  });
                }
                v.tableData = newList;
                v.generalMerchandiseList = newList.filter((item) => item.isNeedCustomization === 0);
              })();
            } else {
              v.tableData = newData;
              v.generalMerchandiseList = newData.filter((item) => item.isNeedCustomization === 0);
            }
          }
        }
      });
    },
    // 更换订单商品
    changeOrderItemBtn() {
      let {allowInvalid} = this.detailsData;
      if (allowInvalid === 0) {
        if (this.generalMerchandiseList.length > 0) {
          this.$refs['replaceYmsOrderGoods'].initReplaceYmsOrderGoodsData(this.detailsData, this.generalMerchandiseList);
        } else {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006133'));
          return false;
        }
      } else {
        this.$refs['replaceYmsOrderGoods'].initReplaceYmsOrderGoodsData(this.detailsData, this.tableData);
      }
    },
    // 取消订单
    cancellationOfOrderBtn() {
      let {allowInvalid, isNeedCustomization} = this.detailsData;
      if (isNeedCustomization === 1) {
        if (allowInvalid === 1) {
          this.$refs['cancelCustomizedProductOrders'].initCancelCustomizedProductOrdersData('distributorCancelOrder', this.detailsData);
        } else {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006134'));
          return false;
        }
      } else {
        this.$refs['cancelYmsOrder'].initCancelYmsOrderData(this.detailsData, this.tableData);
      }
    },
    // 取消订单成功、更换商品成功
    updateYmsOrderSuccess(data) {
      let v = this;
      if (data) {
        const {href} = v.$router.resolve({
          path: '/myOrderDetails',
          query: {
            ymsPackageId: data
          }
        });
        window.open(href, '_blank');
        v.getDetailsData();
      } else {
        v.getDetailsData();
      }
    }
  },
  components: {
    cancelCustomizedProductOrdersModal,
    editReceiverModal,
    cancelYmsOrderModal,
    replaceYmsOrderGoodsModal
  },
};
</script>

<style scoped>

</style>
